import { useQuery, useQueryClient } from '@tanstack/react-query'

import type { TFeedItemApi } from '../../prayer-space/api/feedApi.types'
import type { FEED_ITEM_TYPE } from '../../prayer-space/models/prayerSpace.constants'
import { feedOptions } from '../../prayer-space/services/useInfiniteFeed'
import type { TPublicationApi } from '../api/types/getPublication.types'
import { publicationOptions } from './options/publicationOptions'

export const usePublicationQuery = <T extends TPublicationApi>(id?: number, publication?: T, enabled: boolean = true) =>
  useQuery({
    ...publicationOptions(id),
    placeholderData: publication,
    enabled,
  })

export const usePublicationQuerySeeded = ({ limit = 10, offset = 0 }, sectionOffset: number, id?: number) => {
  const queryClient = useQueryClient()

  return useQuery({
    ...publicationOptions(id),
    placeholderData: () => {
      const cache = queryClient.getQueryData(feedOptions(limit, offset).queryKey)
      if (!cache || sectionOffset >= cache.pages.length) return undefined
      const page = cache.pages[sectionOffset]
      const feedItem = page?.find(
        (item): item is TFeedItemApi<FEED_ITEM_TYPE.PUBLICATION> => item.publication?.id === id,
      )
      // Feed publication is not TPublicationApi; used only as placeholder until the detail GET resolves.
      // oxlint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- feed placeholderData
      return feedItem?.publication as TPublicationApi | undefined
    },
  })
}
